export default __webpack_public_path__ + "static/media/logo.7893aa93.png";